import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { ticketSurfaces } from '../../shared/ticket/ticketSurfaces.styles';

export const purchasesScreenStyles = StyleSheet.create({
  container: {
    ...ticketSurfaces.screen,
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.lg,
  },
  containerCompact: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.md,
  },
  listFlex: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
  },
  wideScrollContent: {
    paddingBottom: spacing.xxl,
  },
  /** Stack de PaperSheets (header + KPIs + alert + lista). */
  stack: {
    gap: 10,
  },
  /** PaperSheet que envuelve la lista de cards + paginación. */
  listSheet: {
    overflow: 'hidden',
  },
  /** Spinner mientras se carga el detalle de una OC al tocar una fila. */
  detailLoadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(244, 249, 247, 0.6)',
  },
  filterTriggerMobile: {
    flex: 1,
    marginBottom: 0,
  },
});
